var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.944 10.365c.42 0 .682.456.471.82a1.636 1.636 0 01-2.83 0 .546.546 0 01.41-.816l.061-.004h1.888zM6 0c2.364 0 4.29 1.88 4.362 4.228l.002.136v2.728c0 .575.445 1.046 1.01 1.088l.153.007c.606.065.63.944.07 1.072l-.07.011-.072.004H.544L.473 9.27c-.63-.067-.63-1.015 0-1.083l.154-.007c.536-.04.965-.467 1.006-1.002l.003-.086V4.364A4.364 4.364 0 016 0zm0 1.091a3.273 3.273 0 00-3.27 3.15l-.003.123v2.728c0 .32-.068.623-.192.897l-.056.115-.045.08h7.131l-.044-.08a2.168 2.168 0 01-.234-.765L9.275 7.2l-.002-.109V4.364A3.273 3.273 0 006 1.091z",
    fill: "currentColor"
  })));
}

export default SvgBell;